// Action Types
export const TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE"
export const SET_DARK_MODE = "SET_DARK_MODE"

// Action Creators
export const toggleDarkMode = () => {
  console.log("Action: toggleDarkMode called")
  return {
    type: TOGGLE_DARK_MODE,
  }
}

export const setDarkMode = (isDarkMode) => {
  console.log("Action: setDarkMode called with", isDarkMode)
  return {
    type: SET_DARK_MODE,
    payload: isDarkMode,
  }
}
